import { apiGet, apiPost } from '../../utils/api';

export const getAllReports = () => apiGet('/reports');

export const getReport = (report_key) => apiGet(`/reports/${report_key}`);

export const postQuery = (report_key, fields) =>
  apiPost(`/reports/${report_key}`, 'get_report', fields, 2);
